module.exports = __webpack_public_path__ + "img/0985_light_grey.0781e7ee.jpg";